import { Card, Col, DatePicker, Row, Select } from 'antd';
import dayjs, { type Dayjs } from 'dayjs';
import type { MonetizationStatsFilters } from './filters';

const STORE_OPTIONS = [
  { label: 'App Store', value: 'APP_STORE' },
  { label: 'Play Store', value: 'PLAY_STORE' },
];

const TIER_OPTIONS = [
  { label: 'Tier 1', value: 'tier_1' },
  { label: 'Tier 2', value: 'tier_2' },
  { label: 'Tier 3', value: 'tier_3' },
];

type Props = {
  value: MonetizationStatsFilters;
  onChange: (next: MonetizationStatsFilters) => void;
};

export const MonetizationFiltersBar = ({ value, onChange }: Props) => {
  const set = <K extends keyof MonetizationStatsFilters>(
    key: K,
    next: MonetizationStatsFilters[K]
  ) => onChange({ ...value, [key]: next });

  const dateRange: [Dayjs | null, Dayjs | null] | undefined =
    value.from_date || value.to_date
      ? [
          value.from_date ? dayjs(value.from_date) : null,
          value.to_date ? dayjs(value.to_date) : null,
        ]
      : undefined;

  return (
    <Card size="small">
      <Row gutter={[12, 12]}>
        <Col xs={24} sm={12} md={8} lg={6}>
          <Select
            allowClear
            placeholder="Sklep"
            options={STORE_OPTIONS}
            value={value.store}
            onChange={(v) => set('store', v)}
            style={{ width: '100%' }}
          />
        </Col>
        <Col xs={24} sm={12} md={8} lg={6}>
          <Select
            allowClear
            placeholder="Tier"
            options={TIER_OPTIONS}
            value={value.tier}
            onChange={(v) => set('tier', v)}
            style={{ width: '100%' }}
          />
        </Col>
        <Col xs={24} sm={24} md={8} lg={12}>
          <DatePicker.RangePicker
            value={dateRange}
            onChange={(dates) =>
              onChange({
                ...value,
                from_date: dates?.[0]?.format('YYYY-MM-DD'),
                to_date: dates?.[1]?.format('YYYY-MM-DD'),
              })
            }
            style={{ width: '100%' }}
          />
        </Col>
      </Row>
    </Card>
  );
};
